import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {FilterOptions} from '../../types'
import {mapShiftEvent} from '../mappers'
import {Task, ShiftEventDto, TaskSchedulesResult, TaskSchedulesResultDto} from '../types'

const QUERY_KEY = 'repetitive-tasks'

const mapRepetitiveTasks = (
  response: TaskSchedulesResultDto,
  timezone: string
): TaskSchedulesResult => {
  return {
    ...response,
    taskSchedules: response.taskSchedules.map(
      (task) => mapShiftEvent(task as ShiftEventDto, timezone) as Task
    )
  }
}

type UseRepetitiveTasksParams = {
  plantId: string
  timezone: string
  filters: FilterOptions
  itemsPerPage?: number
  pageNumber?: number
}

type UseRepetitiveTasksOptions = Omit<UseQueryOptions<TaskSchedulesResult, AxiosError>, 'queryKey'>

export const useRepetitiveTasks = (
  {plantId, timezone, filters, itemsPerPage = 50, pageNumber = 0}: UseRepetitiveTasksParams,
  options?: UseRepetitiveTasksOptions
) => {
  const params = {
    itemsPerPage,
    pageNumber,
    ...filters
  }
  const path = `/shifthandover/${plantId}/search/taskschedules`

  return useQuery<TaskSchedulesResult, AxiosError>({
    queryKey: [QUERY_KEY, filters, params, plantId, timezone],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.post<TaskSchedulesResultDto>(path, params, {
        signal
      })
      return mapRepetitiveTasks(response.data, timezone)
    },
    ...options
  })
}
